module.exports = __webpack_public_path__ + "static/media/activity-exercise-list.d6019646.svg";